import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Vandring: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			{...props}
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
		>
			<path
				d='M0.6 3.19995C0.9325 3.19995 1.2 3.46745 1.2 3.79995V12.2C1.2 12.5325 0.9325 12.8 0.6 12.8C0.2675 12.8 0 12.5325 0 12.2V3.79995C0 3.46745 0.2675 3.19995 0.6 3.19995ZM6.025 4.97495C6.26 5.20995 6.26 5.58995 6.025 5.82245L4.45 7.39745H11.5525L9.9775 5.82245C9.7425 5.58745 9.7425 5.20745 9.9775 4.97495C10.2125 4.74245 10.5925 4.73995 10.825 4.97495L13.425 7.57495C13.66 7.80995 13.66 8.18995 13.425 8.42245L10.825 11.025C10.59 11.26 10.21 11.26 9.9775 11.025C9.745 10.79 9.7425 10.41 9.9775 10.1775L11.5525 8.60245H4.45L6.025 10.1775C6.26 10.4125 6.26 10.7925 6.025 11.025C5.79 11.2575 5.41 11.26 5.1775 11.025L2.575 8.42495C2.34 8.18995 2.34 7.80995 2.575 7.57745L5.175 4.97495C5.41 4.73995 5.79 4.73995 6.0225 4.97495H6.025ZM16 3.79995V12.2C16 12.5325 15.7325 12.8 15.4 12.8C15.0675 12.8 14.8 12.5325 14.8 12.2V3.79995C14.8 3.46745 15.0675 3.19995 15.4 3.19995C15.7325 3.19995 16 3.46745 16 3.79995Z'
				fill={pathFill}
			/>
		</svg>
	);
};
